import React from "react";

function getColor(index: number) {
  if (index === 1) return "text-metallic-orange";
  if (index === 2) return "text-lavender-indigo";
  if (index === 3) return "text-brink-pink";
  return "";
}

const IncomeCard = ({
  title,
  bdt,
  usd,
  eur,
  index,
}: {
  title: string;
  bdt: string | number;
  usd: string | number;
  eur: string | number;
  index: number;
}) => {
  return (
    <div className="default-border py-4 px-6">
      <div className="flex justify-between items-center mb-[5px]">
        <div className="text-body14 text-secondary">{title}</div>
        {/* <InfoCircleOutlined /> */}
      </div>
      <div className={`text-heading30 ${getColor(index)}`}>৳ {bdt}</div>
      <div
        // style={styles.borderColor}
        className="my-[9px] border-0 border-b border-solid borderColor"
      />
      <div className="flex justify-between">
        <div className="text-body14">€ {eur}</div>
        <div className="text-body14">$ {usd}</div>
      </div>
    </div>
  );
};

export default IncomeCard;
